import {environment} from '../../environments/environment';

export class UrlConstants {

  public static END_POINT = 'https://us-central1-angels-babyland-mhss.cloudfunctions.net/';
  public static BRANCH = 'abl-master';
  public static FEE_MGT_BRANCH = 'fee-abl-master';

  public static LOCAL_URL = 'http://localhost:8082';
  public static SITE_URL = 'https://abl.thinkwise.pro/';

  public static BASE_URL = UrlConstants.END_POINT + UrlConstants.BRANCH;
  public static MASTER_SERVICE = UrlConstants.END_POINT + 'academics-' + UrlConstants.BRANCH + '-academics';
  public static MASTER_SERVICE1 = UrlConstants.LOCAL_URL;
  // public static MASTER_SERVICE = "http://localhost:8082";

  public static MASTER_GALLERY_MGMT = UrlConstants.END_POINT + 'gallry-mgmt-' + UrlConstants.BRANCH + '-photo-gallery';
  public static AUTH_SERVICE = UrlConstants.END_POINT + 'auth-' + UrlConstants.BRANCH + '-auth';
  public static EXAM_RESULT_SERVICE = UrlConstants.END_POINT + 'exam-management-' + UrlConstants.BRANCH + '-exam-management';
  // public static EXAM_RESULT_SERVICE = 'http://localhost:8080';

  public static FEE_COLLECTION_SERVICE = UrlConstants.END_POINT + 'fee-management-' + UrlConstants.BRANCH + '-fees-management';


  public static NOTIFICATION_SERVICE = UrlConstants.END_POINT + 'notification-' + UrlConstants.BRANCH + '-notification-management';

  public static BULK_UPLOAD_SERVICE = UrlConstants.END_POINT + 'bulkupload-' + UrlConstants.BRANCH + '-bulkupload';

  // public static SEARCH_SERVICE = 'http://search.medicalconcierge.co.in/api/search/';
  public static IMAGE_END_POINT = UrlConstants.END_POINT + '/' + UrlConstants.BRANCH;
  public static SEARCH_SERVICE = 'https://us-central1-angels-babyland-mhss.cloudfunctions.net/search-management/api/search/';
  public static FEE_MGMT_SEARCH = 'https://us-central1-angels-babyland-mhss.cloudfunctions.net/search-management';

  // public static SEARCH_SERVICE = 'https://search-abl.thinkwise.pro/api/search/';
  // public static FEE_MGMT_SEARCH =  'https://search-abl.thinkwise.pro';

  // public static FEE_MGMT_SEARCH = "http://localhost:3000";

  public static academicYearId = localStorage.getItem('URL_ACADEMIC_YEAR_ID');
  public static ACADEMIC_YEAR = (UrlConstants.academicYearId && UrlConstants.academicYearId !== '') ? UrlConstants.academicYearId : 'current';

  // Auth service
  public static superAdminLogin = UrlConstants.AUTH_SERVICE + '/api/super-admin/login';
  public static adminLogin = UrlConstants.AUTH_SERVICE + '/api/admin/login';
  public static staffLogin = UrlConstants.AUTH_SERVICE + '/api/staff/login';

  public static superAdminProfile = UrlConstants.AUTH_SERVICE + '/api/super-admin/profile';
  public static adminProfile = UrlConstants.AUTH_SERVICE + '/api/admin/profile';
  public static staffProfile = UrlConstants.AUTH_SERVICE + '/api/staff/profile';

  public static addUser = UrlConstants.AUTH_SERVICE + '/api/admin/add-user';
  public static listUsers = UrlConstants.AUTH_SERVICE + '/api/admin/list-users';
  public static listStudents = UrlConstants.AUTH_SERVICE + '/api/admin/list-students';
  public static updateUser = UrlConstants.AUTH_SERVICE + '/api/admin/update-user';
  public static deleteUser = UrlConstants.AUTH_SERVICE + '/api/admin/delete-user';
  public static resetPassword = UrlConstants.AUTH_SERVICE + '/api/admin/reset-password';
  public static updateStaffMobile = UrlConstants.AUTH_SERVICE + '/api/admin/staff/phone';
  public static addStaffCred = UrlConstants.AUTH_SERVICE + '/api/admin/add-staff';
  public static editStaffCred = UrlConstants.AUTH_SERVICE + '/api/admin/reset-staff';

  // Fees Collection service
  public static schoolFeesPaid = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/school/fees-paid';
  public static getFeesPaidCount = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/fees-paid';
  public static getStudentsListData = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/students/list';
  public static getStudentsPaidData = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/students/fees-paid';
  public static addStudentsPaidData = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/fees-paid';
  public static editStudentsPaidData = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/fees-paid';
  public static getFeesCollectionGraphData = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/fees/collection';
  public static getTermFeesNotPaidData = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/term/fees/count';


  // Fee Payment
  public static postFeePayment = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/fee-payment-history';
  public static searchStudentPayment = UrlConstants.FEE_MGMT_SEARCH + '/api/search/admin/' + UrlConstants.ACADEMIC_YEAR + '/fee-payment-history';
  public static getFeePaymentByStudentId = UrlConstants.FEE_MGMT_SEARCH + '/api/search/admin/' + UrlConstants.ACADEMIC_YEAR + '/fee-payment-history';
  public static getFixedFee = UrlConstants.FEE_MGMT_SEARCH + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/fixed-fee';
  public static getFeePaymentHistory = UrlConstants.FEE_MGMT_SEARCH + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/fee-payment-history';
  public static getFeePaymentHistoryForUnpaid = UrlConstants.FEE_MGMT_SEARCH + '/api/admin/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/fee-payment-history';
  public static getTransactionById = UrlConstants.FEE_MGMT_SEARCH + '/api/admin/fee-payment-history/transaction';
  public static getPaymentSummary = UrlConstants.FEE_MGMT_SEARCH + '/api/admin/fee-payment-history/summary';
  public static getPaymentSummaryNew = UrlConstants.FEE_MGMT_SEARCH + '/api/search/report/' + UrlConstants.ACADEMIC_YEAR + '/payment-report-summary';
  public static getStudentGenderReport = UrlConstants.FEE_MGMT_SEARCH + '/api/search/report/' + UrlConstants.ACADEMIC_YEAR + '/school-student-strength';

  // Activity Service
  public static staffActivity = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/teaching_staff';

  // Master Service

  public static academics = UrlConstants.MASTER_SERVICE + '/academic_year';
  public static bootstrap = UrlConstants.MASTER_SERVICE + '/bootstrap';
  public static contactUs = UrlConstants.MASTER_SERVICE + '/contact-us';
  public static sections = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/section';
  public static classes = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/class';
  public static discounts = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/discount';
  public static bankInfo = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/bank-info';
  public static logoInfo = UrlConstants.MASTER_SERVICE + '/logo';
  public static fixedFeeInfo = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/fixed-fee';
  public static fixedFeeInfoName = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/fixed-fee-name';
  public static studentFixedFeeInfo = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/student-fixed-fee';
  public static fixedFeeBankInfo = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/bank-fixed-fee';
  public static updateClassSectionDiscountFixedFee = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/class-section-discount-fixed-fee';

  public static feeTerm = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/fee_term';
  public static classFeeTermGet = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/fee_term';
  public static classFeeTerm = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/class_fee_term';
  public static feedBack = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/feedback';
  public static event = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/event';
  public static holiday = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/holiday';
  public static leave = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/leave';
  public static staff = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/staff/';
  public static permission = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/permission';
  public static pdfDownload = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/permission/student/pdf';
  public static attendance = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/attendance';
  public static absentee = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/absent';
  public static student = UrlConstants.MASTER_SERVICE + +'/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/student';
  public static exam = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/exams';
  public static examByClass = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/class';
  public static subject = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/subject';
  public static chapter = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR;
  public static objQuestion = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR;
  public static setStaff = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR;
  public static subjectByClassSection = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR;
  public static allocateStaff = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/subject/staff';
  public static enquiry = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/enquiry';
  public static admissionEnquiry = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/admission/enquiry';
  public static admissionEnquiryApprove = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/admission/enquiry-approve';
  public static category = UrlConstants.MASTER_GALLERY_MGMT + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/photo-gallery-category';
  public static gallery = UrlConstants.MASTER_GALLERY_MGMT + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/photo-gallery';
  public static staffTimetable = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/teaching_staff';
  public static Existclasses = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/time_table/config/class_list';
  public static getTtConfigByClassList = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/time_table/config/class';
  public static ttConfig = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/time_table/config';
  public static timeTableDays = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/timetable/days'
  public static unallocatedStaff = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/unallocated_staff_time_table';
  public static teachingStaff = UrlConstants.MASTER_SERVICE + '/teaching_staff';
  public static nonTeachingtaff = UrlConstants.MASTER_SERVICE + '/non_teaching_staff';
  public static staffAttendance = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/attendance/staff';
  public static studentAttendanceCount = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/attendance/student/count';
  public static studentAttendance = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/attendance/student';
  public static studentPerformance = UrlConstants.EXAM_RESULT_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/exam_report/student';
  public static subjects = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/subject';
  public static uploadImage = UrlConstants.MASTER_SERVICE + '/image';
  public static uploadFile = UrlConstants.MASTER_SERVICE + '/file';
  public static getImage = UrlConstants.MASTER_SERVICE + '/image';
  public static objExamResult = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR;
  public static applyRetest = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/re-test';

  public static examResult = UrlConstants.EXAM_RESULT_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/exam_report/admin';
  public static markList = UrlConstants.EXAM_RESULT_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/exam_result';
  public static publishExamResult = UrlConstants.EXAM_RESULT_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/exam_report/prepare';
  public static downloadPdf = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/download_pdf';
  public static downloadPdfStudentList = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/print_student_list';
  public static mergePdf = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/merge_blob';
  public static printTc = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/print_tc';
  public static applyTCPost = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/tc';
  public static getTCNumber = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/tcSerialNumber';
  public static UpdateTc = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/UpdateTc';
  public static postPromotion = UrlConstants.MASTER_SERVICE + '/studentPromotion';
  public static transferStudent = UrlConstants.MASTER_SERVICE1 + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/transferStudent';

  // admin dashboard
  public static dashboardStaffNotification = UrlConstants.NOTIFICATION_SERVICE
    + '/api/admin/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/staff/notification';
  public static dashboardChaptersCompleted = UrlConstants.MASTER_SERVICE
    + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/admin_dashboard/chapters_completed';
  public static dashboardChaptersCompletedByStaffs = UrlConstants.MASTER_SERVICE
    + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/admin_dashboard/chapters_completed_by_staffs';
  public static dashboardTodaysBirthday = UrlConstants.MASTER_SERVICE
    + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/admin_dashboard/today_birthdays';
  public static dashboardAnnouncement = UrlConstants.MASTER_SERVICE
    + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/admin_dashboard/announcement';
  public static dashboardFeeCollection = UrlConstants.MASTER_SERVICE
    + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/admin_dashboard/fees_collection';
  public static dashboardAttendance = UrlConstants.MASTER_SERVICE
    + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/admin_dashboard/today_attendance';
  public static dashboardExamResult = UrlConstants.MASTER_SERVICE
    + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/admin_dashboard/exam_result';
  public static dashboardPendingNotification = UrlConstants.MASTER_SERVICE
    + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/admin_dashboard/pending_notification';

  // Student
  public static StudentWrite = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/student';
  public static StudentRead = UrlConstants.MASTER_SERVICE + '/student';
  public static genderSorting = UrlConstants.MASTER_SERVICE + '/student_gender_sort';
  public static StudentReadFromClass = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/student/export_by_class';
  public static StudentReadClass = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR;
  // Staff
  public static StaffWrite = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/teaching_staff';
  public static StaffRead = UrlConstants.MASTER_SERVICE + '/teaching_staff';
  // NonTeachingStaff
  public static NonTeachingStaffWrite = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/non_teaching_staff';
  public static NonTeachingStaffRead = UrlConstants.MASTER_SERVICE + '/non_teaching_staff';

  // Super Admin
  public static KeyValueDataRead = UrlConstants.MASTER_SERVICE + '/school_config';
  public static AppVersionsRead = UrlConstants.MASTER_SERVICE + '/app_version';
  public static AppmoduleRead = UrlConstants.MASTER_SERVICE + '/app_module';

  // Bulk-upload service
  public static StaffUpload = UrlConstants.BULK_UPLOAD_SERVICE + '/bulk/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/staff/profile';
  public static NtStaffUpload = UrlConstants.BULK_UPLOAD_SERVICE + '/bulk/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/non_teaching_staff/profile';
  public static StudentUpload = UrlConstants.BULK_UPLOAD_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/student/profile';
  public static StudentAttendanceUpload = UrlConstants.BULK_UPLOAD_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/student/attendance';
  public static StaffAttendanceUpload = UrlConstants.BULK_UPLOAD_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/staff/attendance';
  public static HolidayUpload = UrlConstants.BULK_UPLOAD_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/announcement/holiday';
  public static EventUpload = UrlConstants.BULK_UPLOAD_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/announcement/event';
  public static ClassFeeTermUpload = UrlConstants.BULK_UPLOAD_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/fee_term';
  public static EnquiryUpload = UrlConstants.BULK_UPLOAD_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/enquiry_upload';
  public static ChapterUpload = UrlConstants.BULK_UPLOAD_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/class/';
  public static ObjectiveQuestionsUpload = UrlConstants.BULK_UPLOAD_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/class/';
  public static StudentFeePaidListUpload = UrlConstants.BULK_UPLOAD_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/class/';
  public static GetClasses = UrlConstants.BULK_UPLOAD_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/class';
  public static GetSubjectsByClassSection = UrlConstants.BULK_UPLOAD_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/class';

  // Staff Management
  public static GetStaffSubject = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/staff';
  public static GetObjectiveQuestions = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/class';
  public static DeleteObjectiveQuestions = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/class';
  public static AddObjectiveQuestion = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/class';
  public static EditObjectiveQuestion = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/class';

  // Search Module
  // public static search = environment.search + UrlConstants.ACADEMIC_YEAR;
  // public static searchNoAcdmic = environment.search;

  public static search = UrlConstants.SEARCH_SERVICE + UrlConstants.ACADEMIC_YEAR;
  public static searchNoAcdmic = UrlConstants.SEARCH_SERVICE;

  public static classByStaffId = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR;
  public static overAllStudentAttendanceByStaffId = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/student_attendance/count';

  // Group Management
  public static getGroup = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/group';
  public static createGroup = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/group';
  public static deleteGroup = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/group';
  public static updateGroup = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/group';

  // Notification Management
  public static getAllAdminNotification = UrlConstants.NOTIFICATION_SERVICE
    + '/api/admin/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification?type=all';
  public static getAdminNotification = UrlConstants.NOTIFICATION_SERVICE
    // public static getAdminNotification = 'http://localhost:8080'
    + '/api/admin/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification?type=approved';
  public static getAdminPendingNotification = UrlConstants.NOTIFICATION_SERVICE
    + '/api/admin/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification?type=pending';
  // public static getAdminPendingNotification = 'http://localhost:8080'
  //   + '/api/admin/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification?type=pending';
  public static deleteNotification = UrlConstants.NOTIFICATION_SERVICE
    + '/api/admin/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/delete/notification';
  public static deleteNotificationStaff = UrlConstants.NOTIFICATION_SERVICE
    + '/api/staff/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/delete/notification';
  public static getAnnouncement = UrlConstants.NOTIFICATION_SERVICE
    + '/api/admin/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification';
  public static getStudentNotification = UrlConstants.NOTIFICATION_SERVICE
    + '/api/admin/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification/student';
  public static getAdminApprovalStatus = UrlConstants.NOTIFICATION_SERVICE
    + '/api/admin/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/admin_approval';
  public static updateAdminApproval = UrlConstants.NOTIFICATION_SERVICE
    + '/api/admin/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/admin_approval';

  public static postAdminNotificationToGroup = UrlConstants.NOTIFICATION_SERVICE
    + '/api/admin/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification/group';
  public static postAdminNotificationToStudent = UrlConstants.NOTIFICATION_SERVICE
    + '/api/admin/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification/student';
  public static postAdminNotificationToClass = UrlConstants.NOTIFICATION_SERVICE
    + '/api/admin/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification/classes';
  public static postAdminApproveNotification = UrlConstants.NOTIFICATION_SERVICE
    + '/api/admin/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification/update';

  public static postAdminNotificationToStaff = UrlConstants.NOTIFICATION_SERVICE
    + '/api/admin/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification/staff';
  public static postAdminNotificationToMember = UrlConstants.NOTIFICATION_SERVICE
    + '/api/admin/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification/members';
  public static postAdminNotificationAnnouncement = UrlConstants.NOTIFICATION_SERVICE
    + '/api/admin/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification/announcement';


  public static getStaffNotificationSent = UrlConstants.NOTIFICATION_SERVICE
    + '/api/staff/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification/for';
  // public static getStaffNotificationSent = 'http://localhost:8080'
  //   + '/api/staff/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification/for';
  public static getStaffNotificationReceived = UrlConstants.NOTIFICATION_SERVICE
    + '/api/staff/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification/for';
  // public static getStaffNotificationReceived = 'http://localhost:8080'
  //   + '/api/staff/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification/for';
  public static postStaffNotificationToGroup = UrlConstants.NOTIFICATION_SERVICE
    + '/api/staff/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification/group';
  public static postStaffNotificationToStudent = UrlConstants.NOTIFICATION_SERVICE
    + '/api/staff/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification/student';
  public static postStaffNotificationToClass = UrlConstants.NOTIFICATION_SERVICE
    + '/api/staff/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification/classes';
  public static getAdminApprovalStatusInStaff = UrlConstants.NOTIFICATION_SERVICE
    + '/api/staff/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/admin_approval';

  public static postStaffNotification = UrlConstants.NOTIFICATION_SERVICE
    + '/api/staff/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification';
  public static postStaffNotificationToMember = UrlConstants.NOTIFICATION_SERVICE
    + '/api/staff/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification/members';

  // SMS From Admin
  public static postAdminSMStoClasses = UrlConstants.NOTIFICATION_SERVICE
    + '/api/admin/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification/classes';
  public static postAdminSMStoStudents = UrlConstants.NOTIFICATION_SERVICE
    + '/api/admin/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/sms/student';
  public static postAdminSMStoGroups = UrlConstants.NOTIFICATION_SERVICE
    + '/api/admin/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification/group';
  public static getAdminSMS = UrlConstants.NOTIFICATION_SERVICE
    + '/api/admin/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/sms?type=all';

  // SMS From Staff
  public static postStaffSMStoClasses = UrlConstants.NOTIFICATION_SERVICE
    + '/api/staff/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification/classes';
  public static postStaffSMStoStudents = UrlConstants.NOTIFICATION_SERVICE
    + '/api/staff/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/sms/student';
  public static postStaffSMStoGroups = UrlConstants.NOTIFICATION_SERVICE
    + '/api/staff/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/notification/group';

  // staff dashboard
  public static dashboardExamReport = UrlConstants.MASTER_SERVICE
    + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/staff_dashboard';
  public static dashboardChapterCompletedbyStaffId = UrlConstants.MASTER_SERVICE
    + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/staff_dashboard';
  public static dashboardAssignment = UrlConstants.MASTER_SERVICE
    + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/staff_dashboard';
  public static dashboardClassAverage = UrlConstants.MASTER_SERVICE
    + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/staff_dashboard';
  public static dashboardStatistics = UrlConstants.MASTER_SERVICE
    + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/staff_dashboard';
  public static dashboardStaffAttendance = UrlConstants.MASTER_SERVICE
    + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/staff_dashboard';

  public static GetImages = UrlConstants.END_POINT + 'gallry-mgmt-' + UrlConstants.BRANCH + '-view-gallery-photo-service';
  // Gallery Photo
  // public static GetImages = UrlConstants.IMAGE_END_POINT + '/cluni_hr_sec_school/' + UrlConstants.ACADEMIC_YEAR;
  // Special fee
  public static SpecialFee = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/special-fee';
  public static AcademicFee = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/academic-fee';
  public static SpecialFeeMapping = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/special-fee-mapping';
  public static getSpecialFeeStudentList = UrlConstants.FEE_MGMT_SEARCH + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/special-fee/student';
  public static getAllAcademicFixedFee = UrlConstants.FEE_MGMT_SEARCH + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/fixed-fee';
  public static getAllAcademicFee = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/academic-fee';
  public static getAllSpecialFee = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/special-fee';
  public static getPassBookData = UrlConstants.FEE_MGMT_SEARCH + '/api/search/admin/' + UrlConstants.ACADEMIC_YEAR + '/fee-passbook';
  public static updateSpecialFeeBank = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/bank-special-fee';
  public static receipt = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/receipt';
  public static getTransactionData = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/fee-payment-details';
  public static getDailySummary = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/daily-fee-summary';
  //Payment history export
  public static paymentHistoryExport = UrlConstants.FEE_MGMT_SEARCH + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/fee-payment-history/export';
  //Cancel History List
  public static getAllcancelFee = UrlConstants.FEE_MGMT_SEARCH + '/api/admin/cancel';
  public static cancelFee = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/cancel';
  public static toggleFeePaymentMode = UrlConstants.FEE_COLLECTION_SERVICE + '/api/admin/' + UrlConstants.ACADEMIC_YEAR + '/online-payment ';

  //Inactive students list
  public static StudentInactive = UrlConstants.SEARCH_SERVICE + UrlConstants.ACADEMIC_YEAR + '/student_status';
  public static GetTCData = UrlConstants.MASTER_SERVICE + '/academic_year/' + UrlConstants.ACADEMIC_YEAR + '/downloadTc';

  //Academic year add
  public static AddAcademicYear = UrlConstants.MASTER_SERVICE + '/academic_year';

  //Academic year add
  public static EditAcademicYear = UrlConstants.MASTER_SERVICE + '/academic_year';

  //Academic year get
  public static GetAcademicYears = UrlConstants.MASTER_SERVICE + '/academic_year';

  //Academic year delete
  public static DeleteAcademicYears = UrlConstants.MASTER_SERVICE + '/academic_year';

  //Academic year Master Data Copy
  public static CopyAcademicYears = UrlConstants.MASTER_SERVICE + '/academic_year/current/copy-masters';

  //login Activity
  public static LoginActivityList = UrlConstants.AUTH_SERVICE + '/api/admin/login-activity/list';
  public static LoginActivityView = UrlConstants.AUTH_SERVICE + '/api/admin/login-activity/view';
  
  public static getServerEnvironment(masterUrl) {
    const baseUrl = masterUrl.split('.')[0];
    const domain = baseUrl.split('/');
    const env = domain[2].split('-')[4];
    if (env !== undefined) {
      return env === 'qa' ? 'qa' : env === 'dev' ? 'master' : env === 'master' ? 'master' : env === 'prod' ? 'prod' : env === 'staging' ? 'staging' : 'master';
      // return env === 'dev' || env === 'qa' ? 'master' : env === 'staging' ? 'master' : 'master';
    } else {
      return 'master';
    }
  }

  public static serverUrl(url) {
    const URL = [];
    URL.push({
      dev: 'https://us-central1-thinkwise-pro.cloudfunctions.net/dev-academics',
      qa: 'https://us-central1-thinkwise-pro.cloudfunctions.net/qa-academics',
      staging: 'https://us-central1-thinkwise-pro.cloudfunctions.net/staging-academics',
      master: 'https://us-central1-thinkwise-pro.cloudfunctions.net/master-academics'
    });

    const baseUrl = url.split('.')[0];
    const domain = baseUrl.split('/');
    const env = domain[2].split('-')[4];
    console.log('## CURRENT ENVIRONMENT ## ', env);
    let SERVER_URL = '';
    if (env !== undefined) {
      for (const x of URL) {
        SERVER_URL = x[env];
      }
    } else {
      SERVER_URL = UrlConstants.MASTER_SERVICE;
    }
    console.log('## SWITCHED ENVIRONMENT ## ', env, ' ## ', SERVER_URL);
    return SERVER_URL;
  }
}
